import { useCallback, useEffect, useState } from 'react';
import Block from '../../components/Base/Block';
import View from '../../components/Base/View';
import './Cart.scss';
import Cartitem from '../../components/CartItem';
import { Button, Empty, Form, Image } from 'antd';
import EmptyTip from '../../components/EmptyTip';
import Loading from '../../components/Loading';
import Price from '../../components/Price';
import Text from '../../components/Base/Text';
import EventBus from '../../utils/EventBus';
import { toast } from '../../utils/toast';
import userUtils from '../../manager/userUtils';
import cartMaganer from '../../manager/cart';
import util from '../../utils/util';

export interface TotalPriceInfo {
  SubTotal: string,
  Shipping: string,
  RequiresShipping: boolean,
  HideShippingTotal: boolean,
  OrderTotal: string,
}

function Cart(prop: {
  withAppBar?: boolean
}) {

  const [products, setProducts] = useState<any[]>([]);
  const [selectedCartIds, setSelectedCardIds] = useState<number[]>([]);
  const [totalPrice, setTotalProce] = useState<TotalPriceInfo>({
    SubTotal: '¥0.00',
    Shipping: '¥0.00',
    RequiresShipping: false,
    HideShippingTotal: true,
    OrderTotal: '¥0.00',
  });

  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isSelectedAll, setSelectedAll] = useState<boolean>(false);
  const [isChecking, setChecking] = useState<boolean>(false);

  /**
  * 初始化数据
  */
  const _init = useCallback(() => {
    cartMaganer.getCartList(false, function (success: boolean, cartList: any, tips: string) {
      if (success) {
        var items = cartList.Items
        if (items.length > 0) {
          // 购物车有商品
          setProducts(cartList.Items)
        } else {
          // 购物车为空
        }
      } else {
      }
      setLoaded(true)
    })
  }, [])

  /**
  * 公开：刷新购物车
  */
  const refresh = useCallback(() => {
    cartMaganer.getCartList(true, function () {
      // Taro.stopPullDownRefresh()
    })
  }, [])


  /**
  * 条目点击
  */
  const _onItemClick = useCallback((productId: number) => {
    util.navigateTo(
      '/detail?isrmmp=1&hidemenu=1&internal=1&id=' + productId + '&updatecartitemid=1'
    )
  }, [])

  /**
    * 选择条目
    */
  const _onSelectItem = useCallback((cartItem: any) => {
    if (isChecking) {
      return
    }
    if (cartItem.Warnings && cartItem.Warnings.length > 0) {
      toast.warning('此商品不可结算')
      return
    }
    var cartId = cartItem.Id;
    setChecking(true);
    console.log('购物车ID：', cartId)
    cartMaganer.changeSelectState(cartId)
  }, [isChecking])


  /**
  * 数量+
  */
  const _onCountAdd = useCallback((cartItem: any) => {
    if (isChecking) {
      return
    }
    var cartId = cartItem.Id
    var currentCount = cartItem.Quantity
    if (currentCount >= cartItem.MaxProductQuantity) {
      toast.warning('该商品限购' + cartItem.MaxProductQuantity + '件')
      return
    }
    setChecking(true)
    cartMaganer.updateQuantity(
      cartId,
      currentCount + 1,
      function (success: boolean, res: any, tips: string) {
        if (!success) {
          toast.error(tips, 2)
          setChecking(false);
        }
      }
    )
  }, [isChecking])

  /**
    * 数量-
    */
  const _onCountSub = useCallback((cartItem: any) => {
    if (isChecking) {
      return
    }
    var cartId = cartItem.Id
    var currentCount = cartItem.Quantity
    if (currentCount <= cartItem.MinProductQuantity) {
      toast.warning('该商品至少需购买' + cartItem.MinProductQuantity + '件')
      return
    }
    if (currentCount > 1) {
      setChecking(true)
      cartMaganer.updateQuantity(
        cartId,
        currentCount - 1,
        function (success: boolean, res: any, tips: string) {
          if (!success) {
            toast.error(tips, 2)
            setChecking(false);
          }
        }
      )
    }
  }, [isChecking])

  /**
    * 修改了数量
    */
  const _countChange = useCallback((cartItem: any, count: number) => {
    setChecking(true)
    cartMaganer.updateQuantity(
      cartItem.Id,
      count,
      function (success: boolean, res: any, tips: string) {
        if (!success) {
          toast.error(tips, 2)
          setChecking(false)
        }
      }
    )
  }, [])

  /**
   * 修改数量弹窗
   */
  const _onCountClick = useCallback((cartItem: any) => {
    if (isChecking) {
      return
    }
    var currentCount = cartItem.Quantity
    //this.selectComponent('.countModifyDialog').open(currentCount, cartItem)
  }, [isChecking])

  /**
     * 删除
     */
  const _onItemDelete = useCallback((cartItem: any) => {
    if (isChecking) {
      return
    }
    var cartId = cartItem.Id
    setChecking(true)
    cartMaganer.removeCart(cartId, function (success: boolean, res: any, tips: string) {
      if (!success) {
        toast.error(tips, 2)
        setChecking(false)
      }
    })
  }, [isChecking]);

  /**
    * 切换全选状态
    */
  const _onSelectAllClick = useCallback(() => {
    if (isChecking) {
      return
    }
    setChecking(true)
    cartMaganer.setSelectAll(!isSelectedAll)
  }, [isChecking, isSelectedAll]);


  /**
     * 结算
     */
  const _goCheckout = useCallback(() => {
    if (!util.allowClick()) {
      return
    }
    if (selectedCartIds.length > 0) {
      console.log("selectedCartIds", selectedCartIds)
      util.navigateTo(
        '/order/checkout?isrmmp=1&hidemenu=1&ids=' + selectedCartIds.join(",")
      )
    } else {
      toast.warning('请先选择商品')
    }
  }, [selectedCartIds]);

  /**
    * 登录
    */
  const emptyBtnClick = useCallback(() => {
    if (!userUtils.isLogin()) {
      userUtils.doTaskInLoginState(function (state) {
        if (state.success) {
          refresh()
        }
      })
    }
  }, [selectedCartIds]);

  useEffect(() => {
    document.title = "购物车";
    // 购物车条目变更
    const cartChanged = function (listInfo: any) {
      setProducts(listInfo.Items);
      setLoaded(true);
      setChecking(false);
    };
    // 购物车选中状态、总价变更
    const cartSelectStateChanged = function (res: any) {
      // console.log("选中ID:", res.selectedIds)
      console.log("res.selectedIds", res.selectedIds)
      if (res.success) {
        setSelectedCardIds(res.selectedIds)
        setTotalProce(res.totalPrice)
        setSelectedAll(res.isSelectedAll)
        setChecking(false);
      } else {
        toast.error(res.error, 2)
        setChecking(false);
      }
    }

    // 登录状态变更
    const loginStateChanged = function (info: any) {
      setIsLogin(userUtils.isLogin())
      if (userUtils.isLogin()) {
        _init()
      } else {
        setProducts([]);
        setSelectedCardIds([]);
        setSelectedAll(false);
        setTotalProce({
          SubTotal: '¥0.00',
          Shipping: '¥0.00',
          RequiresShipping: false,
          HideShippingTotal: true,
          OrderTotal: '¥0.00',
        })
        setLoaded(true);
        setChecking(true);
      }
    }

    EventBus.register(EventBus.names.CART_CHANGE, cartChanged);
    EventBus.register(EventBus.names.CART_SELECT_STATE_CHANGE, cartSelectStateChanged);
    EventBus.register(EventBus.names.USER_LOGIN_STATE_CHANGE, loginStateChanged);

    if (userUtils.isLogin()) {
      _init()
    } else {
      setLoaded(true)
    }
    setIsLogin(userUtils.isLogin())
    return () => {
      EventBus.unregister(EventBus.names.CART_CHANGE, cartChanged)
      EventBus.unregister(EventBus.names.CART_SELECT_STATE_CHANGE, cartSelectStateChanged)
      EventBus.unregister(EventBus.names.USER_LOGIN_STATE_CHANGE, loginStateChanged)
    }
  }, [])

  return (
    <div className={`Cart ${prop.withAppBar ? 'with-appbar' : ''}`}>
      <Block>
        <View style={{
          height: "100%"
        }}>
          {products?.length > 0 ? (
            <View className="cart-list">
              {products?.map((item, orderIndex) => {
                return (
                  <Block key={item.Id}>
                    <Cartitem
                      className="cart-list-item"
                      productInfo={item}
                      selected={isSelected(selectedCartIds, item.Id)}
                      data-index={orderIndex}
                      onItemclickevent={() => { _onItemClick(item.ProductId) }}
                      onCountaddevent={() => { _onCountAdd(item) }}
                      onCountsubevent={() => { _onCountSub(item) }}
                      onSelectclickevent={() => { _onSelectItem(item) }}
                      onDeleteevent={() => { _onItemDelete(item) }}
                      onCountmodiftevent={() => { _onCountClick(item) }}
                    ></Cartitem>
                  </Block>
                )
              })}
            </View>
          ) : loaded ? (
            <View
              className="load-tip-empty"
              style={{
                minHeight: `${window.innerHeight / 20}rem`,
              }}
            >
              {/*  <view wx:if="{{isLogin}}" class="load-tip-text">购物车竟然是空的</view>  */}
              <EmptyTip
                data={{
                  icon: require('../../images/empty-cart.png'),
                  tip: getEmptyTip(isLogin),
                  btn: !userUtils.isLogin() ? getEmptyTipBtn(isLogin) : undefined,
                }}
                emptyBtnClick={emptyBtnClick}
              ></EmptyTip>
            </View>
          ) : (
            <Loading
              style={{
                width: 25,
                height: 25,
                marginTop: 200,
                opacity: 0.5
              }}
            ></Loading>
          )}
          <View>
            {isLogin && products?.length > 0 && (
              <View className="cart-bottm-bar">
                <View className="cart-bottom-left">
                  <View
                    className="select-all-btn"
                    onClick={_onSelectAllClick}
                  >
                    <Image
                      preview={false}
                      className="product-select"
                      src={
                        require('../../images/cart-' +
                          (isSelectedAll ? 'select' : 'unselect') +
                          '.png')
                      }
                    ></Image>
                  </View>
                  <View className="product-price-out">
                    <View className="product-price-total">
                      合计:&nbsp;
                      <Price value={totalPrice.OrderTotal} size={28}></Price>
                    </View>
                    {totalPrice.RequiresShipping &&
                      totalPrice.Shipping != '¥0' &&
                      totalPrice.Shipping != '+¥0' && (
                        <View className="shipping-fee-tip">
                          {totalPrice.HideShippingTotal ? (
                            <Text>不含运费</Text>
                          ) : (totalPrice.Shipping == '¥0' || totalPrice.Shipping == '+ ¥0') ? (
                            <Text>免运费</Text>
                          ) : (
                            <Block>{'含运费' + totalPrice.Shipping}</Block>
                          )}
                          {/*  <price value="{{totalPrice.Shipping}}" size="22" color="#aaaaaa"></price>  */}
                        </View>
                      )}
                  </View>
                </View>
                <Button
                  className={
                    'btn-clear-style product-submit product-submit-' +
                    selectedCartIds?.length
                  }
                  type="default"
                  onClick={_goCheckout}
                >
                  {'去结算(' + selectedCartIds?.length + ')'}
                </Button>
              </View>
            )}
          </View>
        </View>
        {/* <Modifycountmodal
          className="countModifyDialog"
          onCountmodifyconfirm={this._countChange}
        ></Modifycountmodal> */}
        {isChecking && (
          <Loading
            style={{
              position: "fixed",
              top: 200,
              width: 25,
              left: "calc(50% - 13px)",
              height: 25,
              opacity: 0.5
            }}
          ></Loading>
        )}
      </Block>
    </div>
  );
}

function isSelected(selectedIds: number[], cartId: number) {
  return selectedIds.indexOf(cartId) !== -1;
}
function getEmptyTip(isLogin: boolean) {
  return isLogin ? '什么也没有，快去添加吧！' : '';
}
function getEmptyTipBtn(isLogin: boolean) {
  return isLogin ? '搜索商品' : '登录查看购物车';
}

export default Cart;
